(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("@alife/cn-ui"), require("lodash"), require("ReactDOM"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "@alife/cn-ui", "lodash", "ReactDOM"], factory);
	else if(typeof exports === 'object')
		exports["operate-components"] = factory(require("React"), require("@alife/cn-ui"), require("lodash"), require("ReactDOM"));
	else
		root["operate-components"] = factory(root["React"], root["@alife/cn-ui"], root["_"], root["ReactDOM"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__2__, __WEBPACK_EXTERNAL_MODULE__18__, __WEBPACK_EXTERNAL_MODULE__31__) {
return 